import { render } from "./LanguageHandler.vue?vue&type=template&id=29515ae9&scoped=true&ts=true"
import script from "./LanguageHandler.vue?vue&type=script&lang=ts"
export * from "./LanguageHandler.vue?vue&type=script&lang=ts"

import "./LanguageHandler.vue?vue&type=style&index=0&id=29515ae9&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\slow\\slowshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29515ae9"]])

export default __exports__